/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FileTypeTableIcon16Light = forwardRef('FileTypeTableIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.5 1A2.5 2.5 0 0 0 3 3.5v8A2.5 2.5 0 0 0 5.5 14h5a2.5 2.5 0 0 0 2.5-2.5V5.485a1.5 1.5 0 0 0-.44-1.06L9.577 1.438A1.5 1.5 0 0 0 8.516 1H5.5Zm0 1A1.5 1.5 0 0 0 4 3.5V5h2V2h-.5ZM7 2v3h4.722L8.87 2.146A.5.5 0 0 0 8.515 2H7ZM6 6H4v5.5A1.5 1.5 0 0 0 5.5 13H6V6Zm1 7V6h5v5.5a1.5 1.5 0 0 1-1.5 1.5H7Z" })));
});
